var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMsqToken = function SvgMsqToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M6.62.364a1.32 1.32 0 0 0-1.822 0 1.21 1.21 0 0 0 0 1.756l3.446 3.323.81-.78a1.345 1.345 0 0 0 0-1.952zM3.5 1.856l6.732 6.593-1.857 1.819-6.733-6.594zM3.502 6.557l3.447 3.255c.503.5.503 1.312 0 1.813-.502.5-1.317.5-1.82 0L2.693 9.17c-.558-.556-.558-1.252 0-1.808zM11.63 4.952c-.494-.5-1.293-.5-1.786 0a1.294 1.294 0 0 0 0 1.812l.893.906.893-.906c.493-.5.493-1.311 0-1.812M1.263 4.33l.893.906c.494.5.494 1.311 0 1.811-.493.5-1.293.5-1.786 0a1.294 1.294 0 0 1 0-1.811z"
  })));
};
export { SvgMsqToken as ReactComponent };